out vec3 vModelPosition;

void main() {
    vModelPosition = position;
}
